var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"form-rate__total"},[_vm._v("По текущему курсу: "),_c('span',[_vm._v(_vm._s(_vm.convertedAmount))])])}
var staticRenderFns = []

export { render, staticRenderFns }